import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { style: {"color":"red"} }
const _hoisted_2 = ["onMouseover"]
const _hoisted_3 = ["data-id", "src"]
const _hoisted_4 = {
  key: 0,
  class: "productStatus1"
}
const _hoisted_5 = {
  key: 1,
  class: "productStatus2"
}
const _hoisted_6 = {
  key: 2,
  class: "productStatus3"
}
const _hoisted_7 = {
  key: 3,
  class: "productStatus4"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "productCode productMargin" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "productCode productMargin" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { style: {"height":"5px"} }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]

import { reactive,  onMounted,onUnmounted,watch, computed } from 'vue';
import $http from '../http/index';
import { ElMessage,ElBacktop } from 'element-plus';
import moreProductInfo from '../components/MoreProductInfo.vue';
import detailProductInfo from '../components/DetailProductInfo.vue';
import showLargeImage from "../components/ShowLargeImage.vue";
import sizeSearchCondition from '../components/SizeSearchCondition.vue';
import newProductCondition from '../components/NewProductCondition.vue';
import $helper from '../helper/helper';

// 入参
interface CodeSearchDTO{
    TypeCode:string,
    TypeCodeClassfy:string,
    GloryModel: string,
    GloryPartNumber: string,//格莱利零件号
    GloryModelGuid: string,//唯一
    ShowName:  string,
    ShowName2:  string,
    Position:string, // 安装位置
    ReplaceRemark: string,
    ProductSizes: string[],
    MapCode: string,
    PictureFileID:string,
    PictureFileURL:string,
    MiniPictureFileURL:string,
    LargePictureFileURL:string,
    ShowMoreProductInfo:boolean,
    ShowDetailProductInfo:boolean,
    Note:string,
    DevStatus:string,
    DevStatusText:string,
}

// 产品需求
interface ProductRequirement{
    ID:string,
    TypeCode:string,
    GloryModel:string,
    Position:string,
    OE:string,
    RequirementQty:string,
    CarBrand:string,
    CarModel:string,
    Remark:string,
    AnonymityID:string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductList',
  props: {
    loading: { type: Boolean },
    tableData: null,
    tableDataSource: null,
    searchInput: null,
    isOperateSearch: { type: Boolean },
    checkProductTypes: null,
    newProductTime: null
  },
  emits: ['updatedProductRequirement','showSizeSearchData','searching','searched','showNewProductSearchData'],
  setup(__props: any, { emit }) {

const props = __props as {
    loading:boolean  //是否正在查询数据
    tableData:Array<CodeSearchDTO>
    tableDataSource:string
    searchInput:string //查询关键字
    isOperateSearch:boolean //是否执行过查询操作
    checkProductTypes: Array<string> //产品类型选中
    newProductTime:string //新品时间
};





class InitData{
    contentMain = {
        'min-height': '100px',
        'height': '100px',
        'padding': '5px',
        'padding-top': '5px',
        'scroll':'no',
    }
    //tableData:CodeSearchDTO[] = []
    isTotalMsgShow=false //是否显示汇总信息
    tableDataShow:CodeSearchDTO[] = []
    baseBackImage=require('../assets/images/mianBack.png')// 背景图
    backImage=require('../assets/images/mianBack.png')// 背景图
    sizeSearchClassify = 'BrakePads' //尺寸查询条件类别
    compareProducts:Array<CodeSearchDTO>=[] //对比产品
    showCompareProductInfo = false //对比产品显示
    productRequirements:Array<ProductRequirement>=[] //产品需求
    isShowSizeSearchPage=false //显示尺寸查询页
    largeImage={
        isShow:false,
        src:'',
        ImageStyle:{
            left:'0px',
            top:'0px'
        },
        name:''
    }
    anonymityID='' //匿名ID
    totalMsg=""
    navigateHeaderHeight={
        height:"125px"
    }
    isUpdating=false //列表更新中
    windowWidthAndHeight='' //窗口的宽高
    fontStyle={ //文字样式
        'color':'#DDD'
    }
}
const data = reactive(new InitData());

let intervalResult = -1;

onMounted(()=>{
    //背景图
    if($helper.getBrandDecoration().ShowBrandAd){
        data.backImage = `${process.env.VUE_APP_BASE_API}/API/Product/GetPictute?folderId=${$helper.getBrandDecoration().ShowBrandAd}`
    }else{
        data.backImage = data.baseBackImage;
    }
    window.setTimeout(function(){
        if($helper.getBrandDecoration().ShowBrandAd){
            data.backImage = `${process.env.VUE_APP_BASE_API}/API/Product/GetPictute?folderId=${$helper.getBrandDecoration().ShowBrandAd}`
        }else{
            data.backImage = data.baseBackImage;
        }
    },1000)

    adapterSize();
    window.setTimeout(function(){
        adapterSize();
    },1000);
    
    intervalResult = window.setInterval(()=>{
        data.windowWidthAndHeight = window.innerWidth+"-"+window.innerHeight;
    },500)

    let anonymityID = localStorage.getItem("anonymityID");//匿名ID
    if(!anonymityID){
        anonymityID = $helper.createID();
        localStorage.setItem("anonymityID",anonymityID)
    }
    data.anonymityID = anonymityID;

    // 对比产品数据
    // 不直接使用sessionStorage保存 对比产品数据 的原因，不同页面对sessionStorage数据操作会导致数据不一致
    if(!window.sessionStorage.getItem("addOrRemoveCompareProductCacheKey")){
        window.localStorage.setItem("addOrRemoveCompareProduct",'');
        window.sessionStorage.setItem("addOrRemoveCompareProductCacheKey","CacheKey");
    }
    let compareProducts = window.localStorage.getItem("addOrRemoveCompareProduct");
    if( !compareProducts || compareProducts.length < 1){
        data.compareProducts = [];
    }else{
        data.compareProducts = JSON.parse(compareProducts);
    }

    // 产品需求
    getProductRequirement();

    const brandDecoration = $helper.getBrandDecoration();
      //文字颜色
    if(brandDecoration.FontColor){
        data.fontStyle.color=`#${brandDecoration.FontColor}`;
    }
})

onUnmounted(()=>{
    if(intervalResult!=-1){
        window.clearInterval(intervalResult);
    }
})

const blankHeaderStyle = computed(()=>{
    if(isShowTotalMsg()){
        let height = Number.parseInt(data.navigateHeaderHeight.height.replaceAll("px",""));
        return {
            height:`${height+38}px`,
            padding:'0px 0px'
        }
    }
    return {
        height:data.navigateHeaderHeight.height,
        padding:'0px 0px'
    };
})

const totalMsgStyle = computed(()=>{
    let height = Number.parseInt(data.navigateHeaderHeight.height.replaceAll("px",""));
    const brandDecoration = $helper.getBrandDecoration();
    if(brandDecoration.BarColor){
        return {
            'background-color':`#${brandDecoration.BarColor}`,
            'margin-top':`${height+3}px`
        }
    }
    return {
        'margin-top':`${height+3}px`
    }
})

const showImage = (src:string,name:string)=>{
    data.largeImage.isShow=true;
    data.largeImage.src=src;
    data.largeImage.name=name;
}

const hideImage =()=>{
    data.largeImage.isShow=false
}

const productImageOnload = (e: Event)=>{
    const target = e.target as HTMLImageElement;
    let maxWidth = document.getElementsByClassName('productImageWrap')[0].clientWidth-10;
    // 防止图片加载后撑高div
    drawImage(target,100,100);
    let gloryModel = target.getAttribute("data-id");
    if(gloryModel!=null){
        let div = document.getElementById(gloryModel);
        if(div){
            drawImage(target,maxWidth,div.clientHeight);
            target.style.setProperty('margin-top',`${(div.clientHeight -target.height)/2}px`);
        }
    }
}

/**
 * 添加或移除对比产品
 * @param gloryModel 格莱利编码
 * @returns 无返回值
 */
const addOrRemoveCompareProduct = (gloryModel:string)=>{
    let compareProducts = window.localStorage.getItem("addOrRemoveCompareProduct");
    if( !compareProducts || compareProducts.length < 1){
        data.compareProducts = [];
    }else{
        data.compareProducts = JSON.parse(compareProducts);
    }
    // 查找对比产品是否存在，如果存在，那么就移除
    let index = data.compareProducts.findIndex(c=>c.GloryModel == gloryModel)
    if(index>-1){
        data.compareProducts.splice(index,1);
        window.localStorage.setItem("addOrRemoveCompareProduct",JSON.stringify(data.compareProducts));
        return;
    }
    // 添加对比产品,如果产品类别不一致，就先清空原有的对比产品再添加对比产品
    index = props.tableData.findIndex(c=>c.GloryModel == gloryModel);
    if(index<0)return;
    if(data.compareProducts.findIndex(c=>c.TypeCode!=props.tableData[index].TypeCode)>-1){
        data.compareProducts = [];
    }
    data.compareProducts.push(props.tableData[index]);
    window.localStorage.setItem("addOrRemoveCompareProduct",JSON.stringify(data.compareProducts));
}

/**
 * 添加或移除产品需求
 * @param gloryModel 
 */
const addOrMoveProductRequirement=(gloryModel:string)=>{
    let index = data.productRequirements.findIndex(c=>c.GloryModel==gloryModel);
    if(index<0){  // 添加
        $http({
        url: `/API/Product/AddProductRequirement`,
        method: "POST",
        data: {
            gloryModel:gloryModel,
            anonymityID:data.anonymityID
        }
        }).then(res => {
            data.productRequirements = res.data || [];
            emit("updatedProductRequirement",JSON.stringify(data.productRequirements))
        });
    }else{  // 移除
        let removeID = data.productRequirements[index].ID;
        $http({
        url: `/API/Product/RemoveProductRequirement`,
        method: "POST",
        data: {
            ID:removeID,
            anonymityID:data.anonymityID
        }
        }).then(res => {
            data.productRequirements = res.data || [];
            emit("updatedProductRequirement",JSON.stringify(data.productRequirements))
        });
    }
}

/**
 * 查询结果数据统计
 */
const searchDataStatistics = () =>{
    let tableData = props.tableData;
    if(tableData.length==0 && props.isOperateSearch==true){
        ElMessage({
        message: $helper.lan('暂无数据提供'),
        type: 'warning',
        })
    }
    let totalMsg = `找到${tableData.filter(c=>c.TypeCode!="CarModel" && c.TypeCode!="sizeSearchCondition").length}个产品`;
    if(window.localStorage.getItem('lanType')=='EN'){
        totalMsg = `Find ${tableData.filter(c=>c.TypeCode!="CarModel" && c.TypeCode!="sizeSearchCondition").length} products`;
    }
    let brakePads = 0;
    let brakeShoe = 0;
    let warnLine = 0;
    let brakeDisc = 0;
    let brakeDrum = 0;
    let handBrake = 0;
    let annexPackge = 0;
    let childTotalMsg = '';
    for(let i=0;i<tableData.length;i++){
        tableData[i].TypeCodeClassfy = tableData[i].TypeCode;
        tableData[i].GloryModelGuid = `${tableData[i].GloryModelGuid}_${i}`;
        if(tableData[i].TypeCode == "ParkingBrakeShoe"){
            tableData[i].TypeCodeClassfy = "BrakeShoe";//驻车刹车蹄
        }
        if(tableData[i].TypeCodeClassfy =="BrakePads")brakePads++;
        if(tableData[i].TypeCodeClassfy =="BrakeShoe")brakeShoe++;
        if(tableData[i].TypeCodeClassfy =="WarnLine")warnLine++;
        if(tableData[i].TypeCodeClassfy =="BrakeDisc")brakeDisc++;
        if(tableData[i].TypeCodeClassfy =="BrakeDrum")brakeDrum++;
        if(tableData[i].TypeCodeClassfy =="HandBrake")handBrake++;
        if(tableData[i].TypeCodeClassfy =="AnnexPackge")annexPackge++;
    }
    if(brakePads>0){
        childTotalMsg = `${childTotalMsg} , ${$helper.lan('刹车片')} ${brakePads}`;
    }
    if(brakeShoe>0){
        childTotalMsg = `${childTotalMsg} , ${$helper.lan('刹车蹄')} ${brakeShoe}`;
    }
    if(warnLine>0){
        childTotalMsg = `${childTotalMsg} , ${$helper.lan('报警线')} ${warnLine}`;
    }
    if(brakeDisc>0){
        childTotalMsg = `${childTotalMsg} , ${$helper.lan('刹车盘')} ${brakeDisc}`;
    }
    if(brakeDrum>0){
        childTotalMsg = `${childTotalMsg} , ${$helper.lan('刹车鼓')} ${brakeDrum}`;
    }
    if(handBrake>0){
        childTotalMsg = `${childTotalMsg} ,${$helper.lan('手刹片')} ${handBrake}`;
    }
    if(annexPackge>0){
        childTotalMsg = `${childTotalMsg} , ${$helper.lan('附件包')} ${annexPackge}`;
    }
    if(childTotalMsg.length>0){
        childTotalMsg = childTotalMsg.substring(2);
        totalMsg = `${totalMsg} ( ${childTotalMsg} )`;
    }
    data.totalMsg = totalMsg;
    window.setTimeout(function(){
        adapterSize();
    },500);
}

const drawImage = (imgObj:HTMLImageElement, maxWidth:number, maxHeight:number) => {
    var image = new Image();
    image.src = imgObj.src;
    if (image.width > 0 && image.height > 0) {
        let height = image.height;
        let width = image.width;
        let size = calWidthAndHeight(width, height, maxWidth, maxHeight);
        imgObj.width = size.calWidth;
        imgObj.height = size.calHeight;
    }
}

/**
 * 设置列表的展示数据
 */
const setTableDataShow = ()=>{
    let originalTableData = props.tableData;
    searchDataStatistics();
    let temptableData:CodeSearchDTO[] = [];
    for(let i=0;i<originalTableData.length;i++){
    // 车型不用筛选，直接显示
    if(originalTableData[i].TypeCodeClassfy=='CarModel'){
        temptableData.push(originalTableData[i]);
        continue;
    }
    // 尺寸查询条件不用筛选，直接显示
    if(originalTableData[i].TypeCodeClassfy=='sizeSearchCondition'){
        temptableData.push(originalTableData[i]);
        continue;
    }
    //其他公司的产品不用筛选,直接显示
    if(originalTableData[i].TypeCodeClassfy=='otherCompanyProduct'){
        originalTableData[i].PictureFileURL = `${process.env.VUE_APP_BASE_API}/API/Product/GetImageFile?fileId=${originalTableData[i].PictureFileID}`;        
        originalTableData[i].MiniPictureFileURL = `${process.env.VUE_APP_BASE_API}/API/Product/GetImageFileSpecifySize?fileId=${originalTableData[i].PictureFileID}&width=190&height=140&watermarkSize=60&domainName=${$helper.getDomainName()}`;
        originalTableData[i].LargePictureFileURL = `${process.env.VUE_APP_BASE_API}/API/Product/GetImageFileSpecifySize?fileId=${originalTableData[i].PictureFileID}&width=800&height=470&watermarkSize=180&domainName=${$helper.getDomainName()}`;
        temptableData.push(originalTableData[i]);
        continue;
    }
    if(props.checkProductTypes.indexOf(originalTableData[i].TypeCodeClassfy)>-1){
        originalTableData[i].PictureFileURL = `${process.env.VUE_APP_BASE_API}/API/Product/GetImageFile?fileId=${originalTableData[i].PictureFileID}`;        
        originalTableData[i].MiniPictureFileURL = `${process.env.VUE_APP_BASE_API}/API/Product/GetImageFileSpecifySize?fileId=${originalTableData[i].PictureFileID}&width=190&height=140&watermarkSize=60&domainName=${$helper.getDomainName()}`;
        originalTableData[i].LargePictureFileURL = `${process.env.VUE_APP_BASE_API}/API/Product/GetImageFileSpecifySize?fileId=${originalTableData[i].PictureFileID}&width=800&height=470&watermarkSize=180&domainName=${$helper.getDomainName()}`;
        originalTableData[i].ShowName2 = originalTableData[i].ShowName;
        // 编码查询，查询关键字标红
        if(props.tableDataSource =="codeSearch"){
            if(originalTableData[i].MapCode){
                let mapCodes = originalTableData[i].MapCode.split(';');
                let mergeMapCode = '';
                let specialChars = ['_',"-"]; //需要特殊处理的字符
                for(let k=0;k<mapCodes.length;k++){
                    let startIndex = 0;
                    let strLength = -1;
                    let mapCodeStr = mapCodes[k].toLowerCase();
                    let searchInputStr = props.searchInput.toLowerCase();
                    for(let m=0;m<mapCodeStr.length;m++){
                        startIndex=m;
                        let l = props.searchInput.length-1;
                        while(l<100){ //直接使用true编译不通过
                            l++;
                            if(m+l >= mapCodeStr.length+1)break;
                            let firstChart = mapCodeStr.substring(m,m+1);//首字符
                            if(specialChars.indexOf(firstChart)>-1){
                                break; //第一个字符为特殊字符 ，不进行匹配
                            }
                            let mapCodeSubstring = mapCodeStr.substring(m,m+l);
                            for(let y=0;y<specialChars.length;y++){
                                mapCodeSubstring=mapCodeSubstring.replaceAll(specialChars[y],'');
                            }
                            if(mapCodeSubstring && mapCodeSubstring.length>searchInputStr.length){
                                break; //子串的长度已经大于搜索条件，后面不会再匹配上，所以直接返回
                            }
                            if(mapCodeSubstring==searchInputStr){
                                strLength = l
                                break;
                            }                            
                        }
                        if(strLength>0){
                            break;
                        }
                    }
                    if(strLength>0){
                        let matchingStr = mapCodes[k].substring(startIndex,startIndex+strLength);
                        let repalceStr1 = `<span style='color:red'>${matchingStr}</span>`; 
                        mergeMapCode = `${mergeMapCode};${mapCodes[k].replace(matchingStr,repalceStr1)}`;
                    }
                }
                originalTableData[i].MapCode = mergeMapCode.length>0?mergeMapCode.substring(1):'';
            }
            originalTableData[i].ShowName2 = originalTableData[i].ShowName;
            let index2 = originalTableData[i].ShowName.toLowerCase().indexOf(props.searchInput.toLowerCase());
            let repalceStr2 = `<span style='color:red'>${props.searchInput}</span>`; 
            if(index2>-1){
                let matchingStr = originalTableData[i].ShowName.substring(index2,index2+props.searchInput.length);
                repalceStr2 = `<span style='color:red'>${matchingStr}</span>`; 
            }
            originalTableData[i].ShowName = originalTableData[i].ShowName.replace(RegExp(props.searchInput,'i'),repalceStr2);

            //glory零件号
            if(originalTableData[i].GloryPartNumber){
                let index3 = originalTableData[i].GloryPartNumber.toLowerCase().indexOf(props.searchInput.toLowerCase());
                if(index3>-1){
                    let matchingStr = originalTableData[i].GloryPartNumber.substring(index3,index3+props.searchInput.length);
                    repalceStr2 = `<span style='color:red'>${matchingStr}</span>`; 
                }
                originalTableData[i].GloryPartNumber = originalTableData[i].GloryPartNumber.replace(RegExp(props.searchInput,'i'),repalceStr2);
            }
        }
        originalTableData[i].ShowMoreProductInfo = false;
        originalTableData[i].ShowDetailProductInfo = false;
        temptableData.push(originalTableData[i]);
    }
    }
    data.tableDataShow = temptableData;
}

/**
 * 产品对比数量
 */
const compareProductCount = ()=>{
    let compareProducts = window.localStorage.getItem("addOrRemoveCompareProduct");
    if( !compareProducts || compareProducts.length < 1){
        data.compareProducts = [];
    }else{
        data.compareProducts = JSON.parse(compareProducts);
    }
}

watch(()=>props.tableData,()=>{
    compareProductCount()
    if(data.isUpdating)return;
    data.isUpdating=true;
    setTableDataShow();
    window.setTimeout(function(){
        data.isUpdating = false;
    },100);
})

watch(()=>JSON.stringify(props.checkProductTypes),()=>{
    if(data.isUpdating)return;
    data.isUpdating=true;
    setTableDataShow();
    window.setTimeout(function(){
        data.isUpdating = false;
    },100);
})

watch(()=>data.windowWidthAndHeight,()=>{
    adapterSize();
})

const calWidthAndHeight = (width:number, height:number, maxWidth:number, maxHeight:number):any=>{
    let calWidth = width;
    let calHeight = height;
    if (calHeight >= maxHeight || calWidth >= maxWidth) {
        if (calHeight > maxHeight) { //高度超最大高度,使用最大高度并缩小宽度
            calWidth = calWidth * maxHeight / calHeight;
            calHeight = maxHeight;
        }
        if (calWidth > maxWidth) {//宽度超最大宽度,使用最大宽度并缩小高度
            calHeight = calHeight * maxWidth / calWidth;
            calWidth = maxWidth;
        }
        return {
            calWidth: calWidth,
            calHeight: calHeight
        }
    }
    // 宽度放大
    calHeight = maxWidth * calHeight / calWidth;
    calWidth = maxWidth;
    //高度放大
    if(calHeight<maxHeight){
        calWidth = maxHeight * calWidth / calHeight;
        calHeight = maxHeight;
    }
    return calWidthAndHeight(calWidth, calHeight, maxWidth, maxHeight);
}
const adapterSize = ()=>{
    let navigateHeaderHeight = document.getElementsByClassName('navigateHeader')[0]?.clientHeight;
    let contentFootHeight =  document.getElementById('contentFoot')?.clientHeight;
    if(contentFootHeight == undefined){
        contentFootHeight = 0;
    }
    data.navigateHeaderHeight.height = `${navigateHeaderHeight}px`;
    let blankHeaderHeight = document.getElementById("blankHeader")?.clientHeight;
    if(blankHeaderHeight == undefined){
        blankHeaderHeight = 0;
    }
    console.log(`window.innerHeight = ${window.innerHeight}  blankHeaderHeight=${blankHeaderHeight}  contentFootHeight=${contentFootHeight}`);
    let contentMainHeight = (window.innerHeight - blankHeaderHeight - contentFootHeight - 1) + "px"; //多减一个像素，防止出现非必要滚动条
    data.contentMain['min-height'] = contentMainHeight
    data.contentMain['height'] = contentMainHeight
    data.contentMain['padding-top'] = '0px'
    //logoadapter();
};

/**
 * 获取产品需求
 */
const getProductRequirement=()=>{
    $http({
        url: `/API/Product/GetProductRequirement?anonymityID=${data.anonymityID}`,
        method: "GET",
        data: {
        }
    }).then(res => {
        data.productRequirements = res.data || [];
    });
}

/**
 * 展示尺寸查询结果
 * @param resultData 
 */
const showSizeSearchData =(resultData:string,sizeSearchClassify:string)=>{
    emit("showSizeSearchData",resultData,sizeSearchClassify)
}

const showNewProductSearchData=(resultData:string)=>{
    emit("showNewProductSearchData",resultData)
}

/**
 * 查询中
 */
const searching = ()=>{
    emit("searching")
}

/**
 * 查询结束
 */
const searched = ()=>{
    emit("searched")
}

/**
 * 打开产品对比页面
 */
const openCompareProduct = ()=>{
    if(data.compareProducts.length<1){
        ElMessage({
        message: '请先添加对比的产品',
        type: 'warning',
        })
        return
    }
    $helper.openNewPage('/compareProduct');
}

/**
 * 是否显示汇总信息
 */
const isShowTotalMsg = ()=>{
    if(props.isOperateSearch==true){
        return true;
    }
    if(data.tableDataShow.length>0&&data.tableDataShow[0].TypeCodeClassfy=='sizeSearchCondition'){
        return true;
    }
    return false;
}

const backPitureStyle=computed(()=>{
    const height = parseFloat(data.contentMain['height'].replace("px",""))-10
    return{
        height:height+'px',
        width:'100%'
    }
})


return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_CaretRight = _resolveComponent("CaretRight")!
  const _component_DArrowLeft = _resolveComponent("DArrowLeft")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_CaretBottom = _resolveComponent("CaretBottom")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(showLargeImage, {
      "is-show-input": data.largeImage.isShow,
      "image-src": data.largeImage.src,
      "show-text": data.largeImage.name
    }, null, 8, ["is-show-input", "image-src", "show-text"]),
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, {
          id: "blankHeader",
          style: _normalizeStyle(_unref(blankHeaderStyle))
        }, {
          default: _withCtx(() => [
            (isShowTotalMsg())
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 0,
                  class: "totalMsg",
                  style: _normalizeStyle(_unref(totalMsgStyle))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 18 }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          style: _normalizeStyle(data.fontStyle)
                        }, "  " + _toDisplayString(data.totalMsg), 5)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      span: 6,
                      class: "totalMsgCompare"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          onClick: openCompareProduct,
                          style: {"cursor":"pointer","float":"right"}
                        }, [
                          _createElementVNode("span", {
                            style: _normalizeStyle(data.fontStyle)
                          }, _toDisplayString(_unref($helper).lan('对比')) + " : ", 5),
                          _createElementVNode("span", _hoisted_1, _toDisplayString(data.compareProducts.length), 1),
                          _createTextVNode("    ")
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["style"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["style"]),
        _createVNode(_component_el_main, {
          id: "contentMain",
          style: _normalizeStyle(data.contentMain)
        }, {
          default: _withCtx(() => [
            (data.tableDataShow.length<1)
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  style: _normalizeStyle(_unref(backPitureStyle)),
                  src: data.backImage,
                  fit: "fill"
                }, null, 8, ["style", "src"]))
              : _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, { key: 1 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.tableDataShow, (item2) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item2.GloryModelGuid
                      }, [
                        (item2.TypeCodeClassfy=='CarModel')
                          ? (_openBlock(), _createBlock(_component_el_row, {
                              key: 0,
                              class: "carModelRow"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { span: 4 }),
                                _createVNode(_component_el_col, { span: 20 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item2.ShowName), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          : (item2.TypeCodeClassfy=='sizeSearchCondition')
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 1,
                                class: "carModelRow",
                                style: {"padding-top":"0px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(sizeSearchCondition, {
                                        sizeSearchClassify: data.sizeSearchClassify,
                                        onShowSizeSearchData: showSizeSearchData,
                                        onSearching: searching,
                                        onSearched: searched
                                      }, null, 8, ["sizeSearchClassify"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : (item2.TypeCodeClassfy=='newProductSearchCondition')
                              ? (_openBlock(), _createBlock(_component_el_row, {
                                  key: 2,
                                  class: "carModelRow",
                                  style: {"padding-top":"0px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 24 }, {
                                      default: _withCtx(() => [
                                        _createVNode(newProductCondition, {
                                          newProductTime: props.newProductTime,
                                          onShowNewProductSearchData: showNewProductSearchData,
                                          onSearching: searching,
                                          onSearched: searched
                                        }, null, 8, ["newProductTime"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_el_row, {
                                  key: 3,
                                  id: item2.GloryModelGuid,
                                  class: _normalizeClass({productRow:!item2.ShowMoreProductInfo,productRowNoborder:item2.ShowMoreProductInfo})
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 4 }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("div", {
                                          class: "productImageWrap",
                                          onMouseover: ($event: any) => (showImage(item2.LargePictureFileURL,item2.ShowName2)),
                                          onMouseout: hideImage
                                        }, [
                                          _createElementVNode("img", {
                                            "data-id": item2.GloryModelGuid,
                                            alt: "Product Image",
                                            class: "productImage",
                                            src: item2.MiniPictureFileURL,
                                            onLoad: productImageOnload
                                          }, null, 40, _hoisted_3)
                                        ], 40, _hoisted_2), [
                                          [_vShow, item2.TypeCodeClassfy!='otherCompanyProduct']
                                        ]),
                                        (item2.DevStatus=='有')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref($helper).lan('正常供货中')), 1))
                                          : _createCommentVNode("", true),
                                        (item2.DevStatus=='无')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref($helper).lan('无法提供货物')), 1))
                                          : _createCommentVNode("", true),
                                        (item2.DevStatus=='开发中')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref($helper).lan('准备供货中')), 1))
                                          : _createCommentVNode("", true),
                                        (item2.DevStatus=='停售')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref($helper).lan('不再提供货物')), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_col, {
                                      span: 15,
                                      style: _normalizeStyle(item2.TypeCodeClassfy!='otherCompanyProduct'?'min-height: 136px;':'min-height: 10px;')
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: "productName productMargin",
                                          style: _normalizeStyle(item2.TypeCodeClassfy=='otherCompanyProduct'?'color: #CCC;':'')
                                        }, [
                                          _createElementVNode("span", {
                                            innerHTML: item2.ShowName
                                          }, null, 8, _hoisted_8),
                                          _withDirectives(_createElementVNode("span", {
                                            innerHTML: item2.GloryPartNumber,
                                            style: {"padding-left":"20px"}
                                          }, null, 8, _hoisted_9), [
                                            [_vShow, _unref($helper).hasPermission('GloryPartNumber')]
                                          ])
                                        ], 4),
                                        _withDirectives(_createElementVNode("div", { class: "productRelate productMargin" }, _toDisplayString(_unref($helper).lan('型号关系信息')) + " ：" + _toDisplayString(item2.ReplaceRemark), 513), [
                                          [_vShow, item2.ReplaceRemark?true:false]
                                        ]),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.ProductSizes, (size, sizeIndex) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: "productSize productMargin",
                                            key: size
                                          }, [
                                            (item2.TypeCode =='AnnexPackge')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                  (item2.ProductSizes.length>1 )
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(sizeIndex+1) + "：", 1))
                                                    : _createCommentVNode("", true),
                                                  _createTextVNode(_toDisplayString(size), 1)
                                                ]))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                  _createTextVNode(_toDisplayString(_unref($helper).lan('型号尺寸')), 1),
                                                  (item2.ProductSizes.length>1 )
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(sizeIndex+1), 1))
                                                    : _createCommentVNode("", true),
                                                  _createTextVNode("：" + _toDisplayString(size), 1)
                                                ]))
                                          ]))
                                        }), 128)),
                                        _withDirectives(_createElementVNode("div", _hoisted_14, [
                                          _createTextVNode(_toDisplayString(_unref($helper).lan('查找对应编码')) + "：", 1),
                                          _createElementVNode("span", {
                                            innerHTML: item2.MapCode
                                          }, null, 8, _hoisted_15)
                                        ], 512), [
                                          [_vShow, item2.MapCode&&item2.MapCode.length>0?true:false]
                                        ]),
                                        _withDirectives(_createElementVNode("div", _hoisted_16, [
                                          _createTextVNode(_toDisplayString(_unref($helper).lan('车型匹配编码区别')) + "：", 1),
                                          _createElementVNode("span", {
                                            innerHTML: item2.Note
                                          }, null, 8, _hoisted_17)
                                        ], 512), [
                                          [_vShow, item2.Note&&item2.Note.length>0?true:false]
                                        ]),
                                        _withDirectives(_createElementVNode("div", _hoisted_18, null, 512), [
                                          [_vShow, item2.TypeCodeClassfy=='otherCompanyProduct']
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["style"]),
                                    _createVNode(_component_el_col, { span: 5 }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("div", null, [
                                          _withDirectives(_createElementVNode("div", {
                                            class: "productOperate",
                                            onClick: ($event: any) => (addOrRemoveCompareProduct(item2.GloryModel))
                                          }, [
                                            _createElementVNode("span", {
                                              style: _normalizeStyle(data.compareProducts.findIndex(c=>c.GloryModel ==item2.GloryModel)>-1?'color: red;':'')
                                            }, _toDisplayString(_unref($helper).lan('添加产品对比')), 5),
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Plus)
                                              ]),
                                              _: 1
                                            })
                                          ], 8, _hoisted_19), [
                                            [_vShow, _unref($helper).hasPermission('compareProduct')]
                                          ]),
                                          _withDirectives(_createElementVNode("div", {
                                            class: "productOperate",
                                            onClick: ($event: any) => (addOrMoveProductRequirement(item2.GloryModel))
                                          }, [
                                            _createElementVNode("span", {
                                              style: _normalizeStyle(data.productRequirements.findIndex(c=>c.GloryModel ==item2.GloryModel)>-1?'color: red;':'')
                                            }, _toDisplayString(_unref($helper).lan('添加需求')), 5),
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Plus)
                                              ]),
                                              _: 1
                                            })
                                          ], 8, _hoisted_20), [
                                            [_vShow, _unref($helper).hasPermission('productRequirement')]
                                          ]),
                                          _withDirectives(_createElementVNode("div", {
                                            class: "productOperate",
                                            onClick: ($event: any) => (item2.ShowDetailProductInfo = true)
                                          }, [
                                            _createElementVNode("span", null, _toDisplayString(_unref($helper).lan('产品详情页')), 1),
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_CaretRight)
                                              ]),
                                              _: 1
                                            })
                                          ], 8, _hoisted_21), [
                                            [_vShow, _unref($helper).hasPermission('detailProductInfo')]
                                          ]),
                                          _createVNode(_component_el_dialog, {
                                            class: "compareProductInfoDialog",
                                            modelValue: item2.ShowDetailProductInfo,
                                            "onUpdate:modelValue": ($event: any) => ((item2.ShowDetailProductInfo) = $event),
                                            "show-close": false,
                                            width: "1000px",
                                            "align-center": true,
                                            "destroy-on-close": ""
                                          }, {
                                            header: _withCtx(({ close }) => [
                                              _createVNode(_component_el_row, { style: {"margin-bottom":"3px"} }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_col, { span: 21 }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("strong", null, _toDisplayString(item2.ShowName2), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_el_col, { span: 3 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_link, {
                                                        underline: false,
                                                        onClick: close
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_el_icon, { class: "el-icon--left" }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_DArrowLeft)
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createTextVNode(" " + _toDisplayString(_unref($helper).lan('返回搜索界面')), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            footer: _withCtx(() => [
                                              _createVNode(_component_el_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_col, { span: 22 }),
                                                  _createVNode(_component_el_col, { span: 2 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_link, {
                                                        underline: false,
                                                        onClick: ($event: any) => (item2.ShowDetailProductInfo=false)
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan('退出')), 1),
                                                          _createVNode(_component_el_icon, { class: "el-icon--left" }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_Close)
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(detailProductInfo, {
                                                "glory-model": item2.GloryModel,
                                                "type-code": item2.TypeCodeClassfy
                                              }, null, 8, ["glory-model", "type-code"])
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                          _withDirectives(_createElementVNode("div", {
                                            class: "productOperate",
                                            onClick: ($event: any) => (item2.ShowMoreProductInfo = !item2.ShowMoreProductInfo)
                                          }, [
                                            _createElementVNode("span", {
                                              style: _normalizeStyle(item2.ShowMoreProductInfo?'color: red;':'')
                                            }, _toDisplayString(_unref($helper).lan('更多产品信息')), 5),
                                            (!item2.ShowMoreProductInfo)
                                              ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_CaretRight)
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            (item2.ShowMoreProductInfo)
                                              ? (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_CaretBottom)
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ], 8, _hoisted_22), [
                                            [_vShow, _unref($helper).hasPermission('MoreProductInfo')]
                                          ])
                                        ], 512), [
                                          [_vShow, item2.TypeCodeClassfy!='otherCompanyProduct']
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["id", "class"])),
                        (item2.ShowMoreProductInfo)
                          ? (_openBlock(), _createBlock(_component_el_row, { key: 4 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(moreProductInfo, {
                                      "glory-model": item2.GloryModel,
                                      "type-code": item2.TypeCode
                                    }, null, 8, ["glory-model", "type-code"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _createVNode(_unref(ElBacktop), { target: ".el-scrollbar__wrap" })
                  ]),
                  _: 1
                })), [
                  [_directive_loading, props.loading]
                ])
          ]),
          _: 1
        }, 8, ["style"]),
        _createVNode(_component_el_footer, {
          id: "contentFoot",
          style: {"height":"0px","display":"none"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Copyright@2022-2022   珠海格莱利摩擦材料股份有限公司版权所有2   All Rights Reserved ")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})